export const TIME_CONSTANTS = {
  AM: "AM",
  PM: "PM",
  MINUTE_ZERO: "00",
  MINUTE_THIRTY: "30"
};

export const DEFAULT_TIME_RANGE = {
  START_TIME: `12:${TIME_CONSTANTS.MINUTE_ZERO} ${TIME_CONSTANTS.AM}`,
  END_TIME: `12:${TIME_CONSTANTS.MINUTE_THIRTY} ${TIME_CONSTANTS.AM}`
};

export const DATE_TIME = {
  START_TIME: "startTime",
  END_TIME: "endTime"
};

const formatTimeOption = (date) => {
  const hour = date.getHours();
  const minute = date.getMinutes() === 0 ? TIME_CONSTANTS.MINUTE_ZERO : TIME_CONSTANTS.MINUTE_THIRTY;
  const period = hour >= 12 ? TIME_CONSTANTS.PM : TIME_CONSTANTS.AM;
  const formattedHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${formattedHour}:${minute} ${period}`;
};

const formatDateOption = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()}`;
};

// Rounds "now" up to the nearest 30-min slot as the end date/time, and 2 hours
// earlier (also on a 30-min slot) as the start date/time. Start/end are derived
// from the same instants, so a start time rolling back past midnight (e.g. now
// is 12:30 AM on the 15th -> start is 10:30 PM on the 14th) lands on the correct
// calendar day for both fromDate and startTime.
export const getDefaultSearchWindow = () => {
  const end = new Date();
  const minutes = end.getMinutes();
  if (minutes === 0 || minutes === 30) {
    end.setSeconds(0, 0);
  } else if (minutes < 30) {
    end.setMinutes(30, 0, 0);
  } else {
    end.setHours(end.getHours() + 1, 0, 0, 0);
  }

  const start = new Date(end.getTime() - 2 * 60 * 60 * 1000);

  return {
    fromDate: formatDateOption(start),
    toDate: formatDateOption(end),
    timeRange: {
      startTime: formatTimeOption(start),
      endTime: formatTimeOption(end)
    }
  };
};
